import { render, staticRenderFns } from "./HeaderDetails.vue?vue&type=template&id=b75544de&scoped=true&"
import script from "./HeaderDetails.vue?vue&type=script&lang=js&"
export * from "./HeaderDetails.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDetails.vue?vue&type=style&index=0&id=b75544de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75544de",
  null
  
)

export default component.exports